<template>
  <header>
    <div class="row">
      <div class="col-auto btn-sm-col">
        <button
          v-if="showBackBtn"
          class="btn btn-nav"
          @click="goBack()"
        >
          <i class="exu-chevron-left"/>
        </button>
        <button
          v-else-if="showEventListBtn"
          class="btn btn-nav"
          @click="toEventList()"
        >
          <i class="exu-log-out-02"/>
        </button>
      </div>
      <div class="col">
        <div class="title">
          <img
            v-if="showLogo"
            class="title__banner"
            src="/img/agro-app-top.jpg"
            :alt="mainTitle"
          >
          <div
            v-else
            class="title__text"
          >
            <h1>{{ mainTitle }}</h1>
            <p
              v-if="subTitle"
              class="subtitle"
            >
              {{ subTitle }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-auto btn-sm-col">
        <button
          v-if="showRightBtn"
          class="btn btn-nav"
          @click="onRightClick"
        >
          <i
            :class="{'exu-menu-01': !showCross, 'exu-x-close': showCross}"
          />
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MainHeader',
  props: {
    mainTitle: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    // Баннер АГРОСАЛОНа вместо названия и дат мероприятия: заказчик просил
    // ставить его в шапку дашборда и открытого меню. Название остаётся в alt.
    showLogo: {
      type: Boolean,
      default: false,
    },
    // showAsideButton: {
    //   type: Boolean,
    //   default: true,
    // },
    // Настройки открыты. Шапка становится их шапкой: заголовок задаёт App.vue,
    // левая кнопка уходит совсем, правая закрывает панель.
    settingsOpen: {
      type: Boolean,
      default: false,
    },
    btnBack: {
      type: String,
      default: null,
    },
  },
  computed: {
    // Экран, открытый первым (по ссылке, из закладки), назад вёл бы из
    // приложения, поэтому кнопки на нём нет. history.state роутер обновляет
    // раньше $route, так что при пересчёте он уже свежий.
    showBackBtn() {
      return !!this.$route.meta?.showBackBtn && !!window.history.state?.back
        && !this.isOpen && !this.settingsOpen;
    },
    showEventListBtn() {
      return !this.settingsOpen && !this.showBackBtn
        && (this.$store.getters.isVisibleBtnToEventList || this.isOpen);
    },
    showRightBtn() {
      return this.settingsOpen || this.$store.getters.isVisibleBtnMenu;
    },
    showCross() {
      return this.isOpen || this.settingsOpen;
    },
  },
  mounted() {
  },
  methods: {
    onRightClick() {
      if (this.settingsOpen) this.$emit('close-settings');
      else this.$emit('aside-click');
    },
    goBack() {
      this.$router.back();
    },
    toEventList() {
      this.$router.push({ name: 'EventsListView' });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/style/variables.scss';

header {
  position: sticky;
  top: 0;
  z-index: 600;
  grid-area: header;
  display: grid;
  padding: 0 12px;
  background: $color-surface-dark;
  color: $color-base;
  font-family: 'Roboto Condensed';
  // line-height: 1.15rem;

  & > .row {
    align-items: center;
  }

  h1 {
    margin: 0;
    font-size: 16px;
    text-align: center;
    font-weight: 600;

    @media (min-width: 350px) {
      font-size: 20px;
    }
  }
  .subtitle {
    margin: 0;
    font-size: 14px;
    text-align: center;
    font-weight: 400;
  }
  // Баннер или текст — по центру колонки. Высота колонки держится как у двух
  // строк текста, чтобы шапка не прыгала между дашбордом и остальными экранами.
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 44px;
  }
  .title__text {
    min-width: 0;
  }
  // Баннер в две строки (584×94, чёрный фон в цвет шапки): тянем на всю
  // колонку, на широком экране ограничиваем, чтобы не разрастался. Поля
  // сверху и снизу у исходника обрезаны до 8px, иначе шапка росла бы.
  .title__banner {
    display: block;
    width: 100%;
    // 272px — ширина, при которой баннер ровно вписывается в 44px высоты
    max-width: 272px;
    height: auto;
  }
  // Ячейки по краям одинаковые и при пустой кнопке, иначе заголовок уезжает.
  // У колонки border-box с полями по gutter/2, поэтому поля входят в ширину.
  .btn-sm-col {
    width: calc(40px + var(--bs-gutter-x));
  }
  .btn-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    margin: 0;
    border: none;
    color: $color-base;
    font-size: 20px;
    background: rgba(255,255,255,.05);
    &:hover {
      background: rgba(255,255,255,.05);
    }
  }
}
</style>
